import axios from 'axios';
import { IGetGuidImagesRes, IGetGuidInfo } from './types';
import placeholder from './../images/plane_background.png';

const instance = axios.create({
    baseURL: 'https://st.2aw.io:8081/',
});

export default {
    updateInfo: (uid: string, sid: string, data: {}) => {
        return instance.post(`profile/this?uid=${uid}&sid=${sid}`, JSON.stringify(data));
    },

    updateAvatar: (uid: string, sid: string, file: File) => {
        return instance.post(`pictures?uid=${uid}&sid=${sid}&image_number=0`, file, {
            headers: {
                'Content-Type': 'image/jpeg',
            }
        });
    },

    async getGuidInfo(uid: string, sid: string, ex_guide: string) {
        return instance.get<IGetGuidInfo>(`/profile/by_euid?uid=${uid}&sid=${sid}&euid=` + encodeURIComponent(ex_guide))
            .then(async (response) => {
                if (response.data.status === 'ok') {
                    const result = response.data;
                    const imagesRes = await this.getGuidImage(uid, sid, ex_guide);
                    result.images = imagesRes && imagesRes.images.length > 0 ? imagesRes.images : [{
                        image_number: 0,
                        image_url: placeholder,
                        thumb_image_url: placeholder,
                    }];
                    return result;
                }
            });
    },

    async getGuidImage(uid: string, sid: string, ex_guide: string) {
        return instance.get<IGetGuidImagesRes>(`/pictures?uid=${uid}&sid=${sid}&owner=` + encodeURIComponent(ex_guide))
            .then((response) => {
                if (response.data.status === 'ok') {
                    return response.data;
                }
            }, (err) => {
                return {
                    images: []
                };
            })
    },
}